import { render, staticRenderFns } from "./reschedule-appointment.vue?vue&type=template&id=ffb43d64&scoped=true"
import script from "./reschedule-appointment.vue?vue&type=script&lang=js"
export * from "./reschedule-appointment.vue?vue&type=script&lang=js"
import style0 from "./reschedule-appointment.vue?vue&type=style&index=0&id=ffb43d64&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb43d64",
  null
  
)

export default component.exports